import axios from 'axios'
import { HYBIRD_URL } from '@/config/url_config'

// export let fetch = (method, url, data, forceLogin = true) => {
//   return new Promise((resolve, reject) => {
//     axios({
//       ...data,
//       url,
//       method
//     }).then(response => {
//       resolve(response.data)
//     }).catch(err => {
//       if (forceLogin && err.response.status === 401) {
//         console.log('未登录')
//         wechatLogin()
//       } else if (err.response.status === 403) {
//         console.log('无权限')
//         alert('您没有权限访问该页面')
//         window.history.back()
//       } else {
//         Raven.captureException(err)
//         console.log('fetch err', err)
//       }
//       reject(err)
//     })
//   })
// }
// 封装ajax
export const fetch = (method, url, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data: data
    }).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

// 获取用户信息
export let loadUserData = (loginData) => {
  return new Promise((resolve, reject) => {
    let url = `${HYBIRD_URL}/user/loginWithoutTenant`
    fetch('POST', url, loginData).then((data) => {
      console.log('data', data)
      resolve(data)
    }).catch(() => {
      resolve(null)
    })
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js